import { cn } from '@/utils/utils';
import Icon from '@shelflix/ui-web/components/Icon';
import * as React from 'react';

interface SwitchProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

const Switch = React.forwardRef<HTMLButtonElement, SwitchProps>(
  ({ checked, onCheckedChange, disabled = false, className, ...props }, ref) => {
    return (
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        className={cn(
          'peer focus-visible:ring-ring focus-visible:ring-offset-background data-[state=checked]:bg-primary data-[state=unchecked]:bg-input inline-flex h-7 w-14 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
          className
        )}
        data-state={checked ? 'checked' : 'unchecked'}
        onClick={() => onCheckedChange(!checked)}
        ref={ref}
        {...props}
      >
        <span
          className={cn(
            'pointer-events-none flex h-6 w-6 items-center justify-center rounded-full bg-[var(--primary)] shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-7 data-[state=unchecked]:translate-x-0'
          )}
          data-state={checked ? 'checked' : 'unchecked'}
        >
          <Icon
            name={checked ? 'dark_mode' : 'light_mode'}
            size={12}
            className={cn('transition-colors', 'text-gray-300')}
          />
        </span>
      </button>
    );
  }
);

Switch.displayName = 'Switch';

export { Switch };
